import React from "react";
import styles from "../../static/css/pages.module.css";
import Icon from "../../components/icons/icons";
import axios from "axios";

class Banner extends React.Component {

  handleCompleted = (e) => {
    let parent;
    parent = document.querySelector("[data-banner]");
    parent.innerHTML = '';
    axios.get(process.env.REACT_APP_GATE + "registration/updated/stage")
      .then(response => {
        this.setState(response.data)
      })
      .catch(error => {
      });
  }

  render() {
    return(
      <div className="inner" data-banner>
        <div className={styles.successBanner}>
          <Icon name="icon_welcome" viewbox="0 0 1228 180" />
          <div className="l-grid">
            <div className="l-grid__item_4"></div>
            <div className="l-grid__item_8">
              <div className={styles.title_page}>Поздравляем!</div>
              <div className={styles.successBanner_info}>
                Вы успешно зарегистрированы как самозанятый.<br />
                Успехов в вашем деле!
              </div>
              <span className={styles.link} onClick={this.handleCompleted} title="Скрыть">
                    <Icon name="icon_close" viewbox="0 0 24 24" />
                  </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Banner;